/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCalendarContact = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M6.998 4V2h2v2h6V2h2v2h5v5h-2V6h-3v2h-2V6h-6v2h-2V6h-3v14h5v2h-7V4z" />
        <path d="M7 13h2v-2H7zm0 4h2v-2H7zm4-4h1.096a4.91 4.91 0 0 1 .883-2H11zm0 2h1.096c.103.528.287 1.02.536 1.466a5.941 5.941 0 0 0-.696.532l-.003.002H11zm6-4.5c-1.638 0-3 1.266-3 3s1.362 3 3 3 3-1.266 3-3-1.362-3-3-3zm-1 3c0-.591.428-1 1-1s1 .409 1 1-.428 1-1 1-1-.409-1-1zm-2 7.974c0-.649.205-1.142.593-1.486.402-.357 1.132-.672 2.407-.672s2.006.315 2.407.672c.388.344.593.837.593 1.486V22h2v-.526c0-1.097-.366-2.183-1.264-2.981-.884-.786-2.153-1.177-3.736-1.177s-2.852.391-3.736 1.177c-.898.798-1.264 1.884-1.264 2.98V22h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgCalendarContact as CalendarContact };
